import React from 'react';
import classnames from 'classnames';
function Circle() {
    var SIZE = {
        small: {
            viewBox: '25 25 50 50',
            cx: '50',
            cy: '50',
            r: '20'
        }
    };
    return (React.createElement("svg", { viewBox: "25 25 50 50", className: "circular" },
        React.createElement("circle", { className: "path", cx: "50", cy: "50", r: "20", fill: "none" })));
}
function index(_a) {
    var _b = _a.type, type = _b === void 0 ? '' : _b;
    return (React.createElement("div", { className: classnames('spinner-wrapper', {
            'spinner-global': type === 'global',
            'spinner-list': type === 'list'
        }) },
        React.createElement("div", { className: "spinner-ctx" },
            React.createElement(Circle, null),
            React.createElement("p", null, "\u6B63\u5728\u52A0\u8F7D\u4E2D"))));
}
export default index;
